export const LINES_OF_BUSINESS = [
  {
    name: 'Drayage',
    slug: 'drayage',
    localizationSlug: 'DRAYAGE',
    titleize: true,
  },
  {
    name: 'Shorthaul',
    slug: 'shorthaul',
    localizationSlug: 'SHORTHAUL',
    titleize: true,
  },
  {
    name: 'Longhaul',
    slug: 'longhaul',
    localizationSlug: 'LONGHAUL',
    titleize: true,
  },
  { name: 'Rail', slug: 'rail', localizationSlug: 'RAIL', titleize: true },
  {
    name: 'Warehousing',
    slug: 'warehousing',
    localizationSlug: 'WAREHOUSING',
    titleize: true,
  },
];

export const getRegionLinesOfBusiness = () => {
  return LINES_OF_BUSINESS;
};
